export function FilledLinearGraph({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM7.4325 12.1425C7.4325 12.6225 7.0425 13.0125 6.555 13.0125C6.075 13.0125 5.685 12.6225 5.685 12.1425V9.6975C5.685 9.2175 6.075 8.8275 6.555 8.8275C7.0425 8.8275 7.4325 9.2175 7.4325 9.6975V12.1425ZM12.315 12.1425C12.315 12.6225 11.925 13.0125 11.445 13.0125C10.9575 13.0125 10.5675 12.6225 10.5675 12.1425V5.8575C10.5675 5.3775 10.9575 4.9875 11.445 4.9875C11.925 4.9875 12.315 5.3775 12.315 5.8575V12.1425Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
